import React, { useEffect, useRef, useState } from "react";
import { getGanttData, getActivityView } from "../../api/process";
import SidePanel from "../../components/common/layout/SidePanel";
import ActivityView from "../../components/process/ActivityView";
import PageHeader from "../../components/common/ui/PageHeader";

const Construction = ({ projectId }) => {
  const ganttRef = useRef(null);
  const [data, setData] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedActivityview, setSelectedActivityview] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [viewMode, setViewMode] = useState("Month");

  // ===============================
  // 데이터 로드
  // ===============================
  useEffect(() => {
    getGanttData(projectId)
      .then((res) => {
        const safeData = res.map((task) => ({
          ...task,
          dependencies: Array.isArray(task.dependencies)
            ? task.dependencies
            : [],
        }));

        setData(safeData);
        console.log(safeData)
      })
      .catch((err) => {
        console.error("공정 정보 불러오기 실패", err);
      });
  }, [projectId]);

  // ===============================
  // Gantt 렌더링
  // ===============================
  useEffect(() => {
    if (!data?.length) return;

    ganttRef.current.innerHTML = "";

    const gantt = new window.Gantt(ganttRef.current, data, {
      // view_mode: viewMode,
      readonly: true,
      view_mode_select: true,
      container_height: 700,
      show_arrows: false,
      holidays: null,
      view_modes: [
        window.Gantt.VIEW_MODE.DAY,
        window.Gantt.VIEW_MODE.WEEK,
        window.Gantt.VIEW_MODE.MONTH
      ],
      on_click: async (task) => {
        try {
          setSelectedActivity(task);

          const detail = await getActivityView(task.id);
          setSelectedActivityview(detail);

          setIsPanelOpen(true);
        } catch (e) {
          console.error("활동 상세 불러오기 실패", e);
        }
      },
    });

    ganttRef.current.ganttInstance = gantt;
  }, [data, viewMode]);

  // ===============================
  // View Mode 변경
  // ===============================
  const changeView = (mode) => {
    setViewMode(mode);
    const gantt = ganttRef.current.ganttInstance;
    if (gantt) gantt.change_view_mode(mode);
  };

  return (
    <div className="p-6 space-y-6">

      {/* ----------------------------- */}
      {/* 📌 상단 헤더 */}
      {/* ----------------------------- */}
      <PageHeader>공정표 조회</PageHeader>

      {/* ----------------------------- */}
      {/* 📌 View Mode 버튼 / 필터 */}
      {/* ----------------------------- */}
      {/* <div className="flex items-center justify-between mb-2">

        <div className="flex gap-2">
          {[
            { key: "Day", label: "일" },
            { key: "Week", label: "주" },
            { key: "Month", label: "월" },
          ].map((m) => (
            <button
              key={m.key}
              onClick={() => changeView(m.key)}
              className={[
                "px-4 py-1.5 rounded-lg text-sm border transition",
                viewMode === m.key
                  ? "bg-blue-600 border-blue-600 text-white"
                  : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50",
              ].join(" ")}
            >
              {m.label}
            </button>
          ))}
        </div>
      </div> */}

      {/* ----------------------------- */}
      {/* 📌 Gantt Container */}
      {/* ----------------------------- */}
      <div className="border rounded-lg bg-white w-full h-[700px] overflow-hidden relative">
        <div ref={ganttRef} className="w-full h-full" />
      </div>


      {/* ----------------------------- */}
      {/* 📌 우측 슬라이드 패널 */}
      {/* ----------------------------- */}
      <SidePanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
        title={selectedActivity?.name}
        width={1000}
        side="right"
      >
        {selectedActivity && (
          <ActivityView
            activity={selectedActivity}
            ganttData={selectedActivityview}
          />
        )}
      </SidePanel>
    </div>
  );
};

export default Construction;
